export const MODAL_STATES = Object.freeze({
  OPEN: 'isOpen',
  CLOSE: 'isClose',
})
